import styled from 'styled-components';
import bgModalImg from 'assets/images/banner-resumo-do-edital.svg';

export const Container = styled.div`
  .modal-summary {
    background: url('${bgModalImg}') no-repeat 95% 70%;
    background-size: 43%;
    height: 350px;

    @media only screen and (max-width: 368px) {
      background: none;
    }
  }
  .font-scale {
    font-size: 1.05rem;
  }

  .close {
    position: absolute;
    right: 10px;
    top: 5px;
  }

  .badge-new {
    color: ${(props) => props.theme.$black};
    background: ${(props) => props.theme.$warning};
  }

  .text-green {
    color: ${(props) => props.theme.$medium_green};
  }
`;
